import React from "react";

import { Card, CardProps } from "@mui/material";

interface Props extends CardProps {
  children: React.ReactNode;
}

export default function InsightCardShell({ children, sx, ...rest }: Props) {
  return (
    <Card
      sx={{
        width: "100%",
        backgroundColor: "background.paper",
        boxShadow: "none",
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        p: 2,
        transition: "border-color 0.2s ease, box-shadow 0.2s ease",
        "&:hover": {
          borderColor: "rgba(37, 99, 235, 0.28)",
          boxShadow: "0 10px 20px rgba(15, 23, 42, 0.06)",
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Card>
  );
}
